import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Text, Stack, Checkbox } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ErrorMessages } from '@bingads-webui-react/validation';

import { getIntentTargetingStyles } from './styles/intent-targeting-style';
import { SectionShimmer } from './utils/shimmer-element';

const stackTokens = { childrenGap: 5 };

export function LocationTargetingIntent({
  isPeopleInLocationChecked,
  isPeopleSearchingForLocationChecked,
  onPeopleInLocationChange,
  onPeopleSearchingForLocationChange,
  updateErrorMessage,
  strings,
  isLoading,
}) {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getIntentTargetingStyles);

  const errorMessage = (isPeopleInLocationChecked || isPeopleSearchingForLocationChecked)
    ? undefined
    : i18n.getString(_TL_('At least one intent option must be selected'));

  const titleLabel = strings.intentTitle ? strings.intentTitle : i18n.getString(_TL_('Who should see your ads?'));
  const checkboxLabel1 = strings.intentText1 ? strings.intentText1 : i18n.getString(_TL_('People in your targeted locations'));
  const checkboxLabel2 = strings.intentText2 ? strings.intentText2 : i18n.getString(_TL_('People searching for or viewing pages about your targeted locations'));

  useEffect(() => {
    updateErrorMessage(prev => ({ ...prev, intent: errorMessage }));
  }, [errorMessage, updateErrorMessage]);

  return (
    <div className={classNames('intent-target', classes.intentTarget)}>
      <div className={classes.title}>
        <Text>{titleLabel}</Text>
      </div>
      <div className={classNames('intent-target-options', classes.intentTargetOptions)}>
        {
          isLoading ?
            (<SectionShimmer />)
            : (
              <Stack tokens={stackTokens}>
                <Checkbox
                  label={checkboxLabel1}
                  checked={isPeopleInLocationChecked}
                  onChange={(ev, isChecked) => {
              onPeopleInLocationChange(isChecked);
            }}
                />
                <Checkbox
                  label={checkboxLabel2}
                  checked={isPeopleSearchingForLocationChecked}
                  onChange={(ev, isChecked) => {
              onPeopleSearchingForLocationChange(isChecked);
            }}
                />
                {
            errorMessage && (
              <ErrorMessages
                className={classes.errormessage}
                messages={[errorMessage]}
              />
            )
          }
              </Stack>
            )
        }

      </div>
    </div>
  );
}

LocationTargetingIntent.propTypes = {
  isPeopleInLocationChecked: PropTypes.bool.isRequired,
  isPeopleSearchingForLocationChecked: PropTypes.bool.isRequired,
  onPeopleInLocationChange: PropTypes.func.isRequired,
  onPeopleSearchingForLocationChange: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    intentTitle: PropTypes.string,
    intentText1: PropTypes.string,
    intentText2: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

LocationTargetingIntent.defaultProps = {
  strings: {},
  isLoading: false,
};
